module.exports = __webpack_public_path__ + "img/produit_3.1d0cef67.png";